'use strict';

module.exports = [
    { level: '1', code: '2060-2', label: 'African', description: 'African' },
    {
        level: '2',
        code: '2058-6',
        label: 'African American',
        description: 'African American'
    },
    {
        level: '2',
        code: '1004-1',
        label: 'American Indian',
        description: 'American Indian'
    },
    { level: '2', code: '2028-9', label: 'Asian', description: 'Asian' },
    { level: '2', code: '2108-9', label: 'European', description: 'European' },
    {
        level: '2',
        code: '2076-8',
        label: 'Hawaiian or Other Pacific Islander',
        description: 'Native Hawaiian or Other Pacific Islander'
    },
    {
        level: '2',
        code: '2118-8',
        label: 'Middle Eastern or North African',
        description: 'Middle Eastern or North African'
    },
    { level: '2', code: '2106-3', label: 'White', description: 'White' },
    {
        level: '3',
        code: '2131-1',
        label: 'Other',
        description:
            'Note that this term remains in the table for completeness, even though within HL7, the notion of Other code is deprecated.'
    },
    {
        level: '4',
        code: '1002-5',
        label: 'American Indian or Alaska Native',
        description: 'American Indian or Alaska Native'
    },
    { level: '4', code: '1006-6', label: 'Abenaki', description: 'Abenaki' },
    {
        level: '4',
        code: '1008-2',
        label: 'Algonquian',
        description: 'Algonquian'
    },
    { level: '4', code: '1010-8', label: 'Apache', description: 'Apache' },
    {
        level: '4',
        code: '1011-6',
        label: 'Chiricahua',
        description: 'Chiricahua'
    },
    {
        level: '4',
        code: '1012-4',
        label: 'Fort Sill Apache',
        description: 'Fort Sill Apache'
    },
    {
        level: '4',
        code: '1013-2',
        label: 'Jicarilla Apache',
        description: 'Jicarilla Apache'
    },
    {
        level: '4',
        code: '1014-0',
        label: 'Lipan Apache',
        description: 'Lipan Apache'
    },
    {
        level: '4',
        code: '1015-7',
        label: 'Mescalero Apache',
        description: 'Mescalero Apache'
    },
    {
        level: '4',
        code: '1016-5',
        label: 'Oklahoma Apache',
        description: 'Oklahoma Apache'
    },
    {
        level: '4',
        code: '1017-3',
        label: 'Payson Apache',
        description: 'Payson Apache'
    },
    {
        level: '4',
        code: '1018-1',
        label: 'San Carlos Apache',
        description: 'San Carlos Apache'
    },
    {
        level: '4',
        code: '1019-9',
        label: 'White Mountain Apache',
        description: 'White Mountain Apache'
    },
    { level: '4', code: '1021-5', label: 'Arapaho', description: 'Arapaho' },
    {
        level: '4',
        code: '1022-3',
        label: 'Northern Arapaho',
        description: 'Northern Arapaho'
    },
    {
        level: '4',
        code: '1023-1',
        label: 'Southern Arapaho',
        description: 'Southern Arapaho'
    },
    {
        level: '4',
        code: '1024-9',
        label: 'Wind River Arapaho',
        description: 'Wind River Arapaho'
    },
    { level: '4', code: '1026-4', label: 'Arikara', description: 'Arikara' },
    {
        level: '4',
        code: '1028-0',
        label: 'Assiniboine',
        description: 'Assiniboine'
    },
    {
        level: '4',
        code: '1030-6',
        label: 'Assiniboine Sioux',
        description: 'Assiniboine Sioux'
    },
    {
        level: '4',
        code: '1031-4',
        label: 'Fort Peck Assiniboine Sioux',
        description: 'Fort Peck Assiniboine Sioux'
    },
    { level: '4', code: '1033-0', label: 'Bannock', description: 'Bannock' },
    {
        level: '4',
        code: '1035-5',
        label: 'Blackfeet',
        description: 'Blackfeet'
    },
    {
        level: '4',
        code: '1037-1',
        label: 'Brotherton',
        description: 'Brotherton'
    },
    {
        level: '4',
        code: '1039-7',
        label: 'Burt Lake Band',
        description: 'Burt Lake Band'
    },
    { level: '4', code: '1041-3', label: 'Caddo', description: 'Caddo' },
    {
        level: '4',
        code: '1042-1',
        label: 'Oklahoma Cado',
        description: 'Oklahoma Cado'
    },
    { level: '4', code: '1044-7', label: 'Cahuilla', description: 'Cahuilla' },
    {
        level: '4',
        code: '1045-4',
        label: 'Agua Caliente Cahuilla',
        description: 'Agua Caliente Cahuilla'
    },
    {
        level: '4',
        code: '1046-2',
        label: 'Augustine',
        description: 'Augustine'
    },
    { level: '4', code: '1047-0', label: 'Cabazon', description: 'Cabazon' },
    {
        level: '4',
        code: '1048-8',
        label: 'Los Coyotes',
        description: 'Los Coyotes'
    },
    { level: '4', code: '1049-6', label: 'Morongo', description: 'Morongo' },
    {
        level: '4',
        code: '1050-4',
        label: 'Santa Rosa Cahuilla',
        description: 'Santa Rosa Cahuilla'
    },
    {
        level: '4',
        code: '1051-2',
        label: 'Torres-Martinez',
        description: 'Torres-Martinez'
    },
    {
        level: '4',
        code: '1053-8',
        label: 'California Tribes',
        description: 'California Tribes'
    },
    { level: '4', code: '1054-6', label: 'Cahto', description: 'Cahto' },
    {
        level: '4',
        code: '1055-3',
        label: 'Chimariko',
        description: 'Chimariko'
    },
    {
        level: '4',
        code: '1056-1',
        label: 'Coast Miwok',
        description: 'Coast Miwok'
    },
    { level: '4', code: '1057-9', label: 'Digger', description: 'Digger' },
    { level: '4', code: '1058-7', label: 'Kawaiisu', description: 'Kawaiisu' },
    {
        level: '4',
        code: '1059-5',
        label: 'Kern River',
        description: 'Kern River'
    },
    { level: '4', code: '1060-3', label: 'Mattole', description: 'Mattole' },
    { level: '4', code: '1061-1', label: 'Red Wood', description: 'Red Wood' },
    {
        level: '4',
        code: '1062-9',
        label: 'Santa Rosa',
        description: 'Santa Rosa'
    },
    { level: '4', code: '1063-7', label: 'Takelma', description: 'Takelma' },
    { level: '4', code: '1064-5', label: 'Wappo', description: 'Wappo' },
    { level: '4', code: '1065-2', label: 'Yana', description: 'Yana' },
    { level: '4', code: '1066-0', label: 'Yuki', description: 'Yuki' },
    {
        level: '4',
        code: '1068-6',
        label: 'Canadian and Latin American Indian',
        description: 'Canadian and Latin American Indian'
    },
    {
        level: '4',
        code: '1069-4',
        label: 'Canadian Indian',
        description: 'Canadian Indian'
    },
    {
        level: '4',
        code: '1070-2',
        label: 'Central American Indian',
        description: 'Central American Indian'
    },
    {
        level: '4',
        code: '1071-0',
        label: 'French American Indian',
        description: 'French American Indian'
    },
    {
        level: '4',
        code: '1072-8',
        label: 'Mexican American Indian',
        description: 'Mexican American Indian'
    },
    {
        level: '4',
        code: '1073-6',
        label: 'South American Indian',
        description: 'South American Indian'
    },
    {
        level: '4',
        code: '1074-4',
        label: 'Spanish American Indian',
        description: 'Spanish American Indian'
    },
    { level: '4', code: '1076-9', label: 'Catawba', description: 'Catawba' },
    { level: '4', code: '1741-8', label: 'Alatna', description: 'Alatna' },
    {
        level: '4',
        code: '1742-6',
        label: 'Alexander',
        description: 'Alexander'
    },
    {
        level: '4',
        code: '1743-4',
        label: 'Allakaket',
        description: 'Allakaket'
    },
    { level: '4', code: '1744-2', label: 'Alanvik', description: 'Alanvik' },
    { level: '4', code: '1745-9', label: 'Anvik', description: 'Anvik' },
    { level: '4', code: '1746-7', label: 'Arctic', description: 'Arctic' },
    { level: '4', code: '1747-5', label: 'Beaver', description: 'Beaver' },
    {
        level: '4',
        code: '1748-3',
        label: 'Birch Creek',
        description: 'Birch Creek'
    },
    { level: '4', code: '1749-1', label: 'Cantwell', description: 'Cantwell' },
    {
        level: '4',
        code: '1750-9',
        label: 'Chalkyitsik',
        description: 'Chalkyitsik'
    },
    {
        level: '4',
        code: '1751-7',
        label: 'Chickaloon',
        description: 'Chickaloon'
    },
    {
        level: '4',
        code: '1752-5',
        label: 'Chistochina',
        description: 'Chistochina'
    },
    { level: '4', code: '1753-3', label: 'Chitina', description: 'Chitina' },
    { level: '4', code: '1754-1', label: 'Circle', description: 'Circle' },
    {
        level: '4',
        code: '1755-8',
        label: 'Cook Inlet',
        description: 'Cook Inlet'
    },
    {
        level: '4',
        code: '1756-6',
        label: 'Copper Center',
        description: 'Copper Center'
    },
    {
        level: '4',
        code: '1757-4',
        label: 'Copper River',
        description: 'Copper River'
    },
    { level: '4', code: '1758-2', label: 'Dot Lake', description: 'Dot Lake' },
    { level: '4', code: '1759-0', label: 'Doyon', description: 'Doyon' },
    { level: '4', code: '1760-8', label: 'Eagle', description: 'Eagle' },
    { level: '4', code: '1761-6', label: 'Eklutna', description: 'Eklutna' },
    {
        level: '4',
        code: '1762-4',
        label: 'Evansville',
        description: 'Evansville'
    },
    {
        level: '4',
        code: '1763-2',
        label: 'Fort Yukon',
        description: 'Fort Yukon'
    },
    { level: '4', code: '1764-0', label: 'Gakona', description: 'Gakona' },
    { level: '4', code: '1765-7', label: 'Galena', description: 'Galena' },
    { level: '4', code: '1766-5', label: 'Grayling', description: 'Grayling' },
    { level: '4', code: '1767-3', label: 'Gulkana', description: 'Gulkana' },
    {
        level: '4',
        code: '1768-1',
        label: 'Healy Lake',
        description: 'Healy Lake'
    },
    {
        level: '4',
        code: '1769-9',
        label: 'Holy Cross',
        description: 'Holy Cross'
    },
    { level: '4', code: '1770-7', label: 'Hughes', description: 'Hughes' },
    { level: '4', code: '1771-5', label: 'Huslia', description: 'Huslia' },
    { level: '4', code: '1772-3', label: 'Iliamna', description: 'Iliamna' },
    { level: '4', code: '1773-1', label: 'Kaltag', description: 'Kaltag' },
    {
        level: '4',
        code: '1774-9',
        label: 'Kluti Kaah',
        description: 'Kluti Kaah'
    },
    { level: '4', code: '1775-6', label: 'Knik', description: 'Knik' },
    { level: '4', code: '1776-4', label: 'Koyukuk', description: 'Koyukuk' },
    {
        level: '4',
        code: '1777-2',
        label: 'Lake Minchumina',
        description: 'Lake Minchumina'
    },
    { level: '4', code: '1778-0', label: 'Lime', description: 'Lime' },
    { level: '4', code: '1779-8', label: 'Mcgrath', description: 'Mcgrath' },
    {
        level: '4',
        code: '1780-6',
        label: 'Manley Hot Springs',
        description: 'Manley Hot Springs'
    },
    {
        level: '4',
        code: '1781-4',
        label: 'Mentasta Lake',
        description: 'Mentasta Lake'
    },
    { level: '4', code: '1782-2', label: 'Minto', description: 'Minto' },
    { level: '4', code: '1783-0', label: 'Nenana', description: 'Nenana' },
    { level: '4', code: '1784-8', label: 'Nikolai', description: 'Nikolai' },
    {
        level: '4',
        code: '1785-5',
        label: 'Ninilchik',
        description: 'Ninilchik'
    },
    {
        level: '4',
        code: '1786-3',
        label: 'Nondalton',
        description: 'Nondalton'
    },
    { level: '4', code: '1787-1', label: 'Northway', description: 'Northway' },
    { level: '4', code: '1788-9', label: 'Nulato', description: 'Nulato' },
    {
        level: '4',
        code: '1789-7',
        label: 'Pedro Bay',
        description: 'Pedro Bay'
    },
    { level: '4', code: '1790-5', label: 'Rampart', description: 'Rampart' },
    { level: '4', code: '1791-3', label: 'Ruby', description: 'Ruby' },
    {
        level: '4',
        code: '1792-1',
        label: 'Salamatof',
        description: 'Salamatof'
    },
    { level: '4', code: '1793-9', label: 'Seldovia', description: 'Seldovia' },
    { level: '4', code: '1794-7', label: 'Slana', description: 'Slana' },
    { level: '4', code: '1795-4', label: 'Shageluk', description: 'Shageluk' },
    { level: '4', code: '1796-2', label: 'Stevens', description: 'Stevens' },
    {
        level: '4',
        code: '1797-0',
        label: 'Stony River',
        description: 'Stony River'
    },
    { level: '4', code: '1798-8', label: 'Takotna', description: 'Takotna' },
    {
        level: '4',
        code: '1799-6',
        label: 'Tanacross',
        description: 'Tanacross'
    },
    { level: '4', code: '1800-2', label: 'Tanaina', description: 'Tanaina' },
    { level: '4', code: '1801-0', label: 'Tanana', description: 'Tanana' },
    {
        level: '4',
        code: '1802-8',
        label: 'Tanana Chiefs',
        description: 'Tanana Chiefs'
    },
    { level: '4', code: '1803-6', label: 'Tazlina', description: 'Tazlina' },
    { level: '4', code: '1804-4', label: 'Telida', description: 'Telida' },
    { level: '4', code: '1805-1', label: 'Tetlin', description: 'Tetlin' },
    { level: '4', code: '1806-9', label: 'Tok', description: 'Tok' },
    { level: '4', code: '1807-7', label: 'Tyonek', description: 'Tyonek' },
    { level: '4', code: '1808-5', label: 'Venetie', description: 'Venetie' },
    { level: '4', code: '1809-3', label: 'Wiseman', description: 'Wiseman' },
    { level: '4', code: '1078-5', label: 'Cayuse', description: 'Cayuse' },
    { level: '4', code: '1080-1', label: 'Chehalis', description: 'Chehalis' },
    {
        level: '4',
        code: '1082-7',
        label: 'Chemakuan',
        description: 'Chemakuan'
    },
    { level: '4', code: '1083-5', label: 'Hoh', description: 'Hoh' },
    { level: '4', code: '1084-3', label: 'Quileute', description: 'Quileute' },
    {
        level: '4',
        code: '1086-8',
        label: 'Chemehuevi',
        description: 'Chemehuevi'
    },
    { level: '4', code: '1088-4', label: 'Cherokee', description: 'Cherokee' },
    {
        level: '4',
        code: '1089-2',
        label: 'Cherokee Alabama',
        description: 'Cherokee Alabama'
    },
    {
        level: '4',
        code: '1090-0',
        label: 'Cherokees of Northeast Alabama',
        description: 'Cherokees of Northeast Alabama'
    },
    {
        level: '4',
        code: '1091-8',
        label: 'Cherokees of Southeast Alabama',
        description: 'Cherokees of Southeast Alabama'
    },
    {
        level: '4',
        code: '1092-6',
        label: 'Eastern Cherokee',
        description: 'Eastern Cherokee'
    },
    {
        level: '4',
        code: '1093-4',
        label: 'Echota Cherokee',
        description: 'Echota Cherokee'
    },
    {
        level: '4',
        code: '1094-2',
        label: 'Etowah Cherokee',
        description: 'Etowah Cherokee'
    },
    {
        level: '4',
        code: '1095-9',
        label: 'Northern Cherokee',
        description: 'Northern Cherokee'
    },
    { level: '4', code: '1096-7', label: 'Tuscola', description: 'Tuscola' },
    {
        level: '4',
        code: '1097-5',
        label: 'United Keetowah Band of Cherokee',
        description: 'United Keetowah Band of Cherokee'
    },
    {
        level: '4',
        code: '1098-3',
        label: 'Western Cherokee',
        description: 'Western Cherokee'
    },
    {
        level: '4',
        code: '1100-7',
        label: 'Cherokee Shawnee',
        description: 'Cherokee Shawnee'
    },
    { level: '4', code: '1102-3', label: 'Cheyenne', description: 'Cheyenne' },
    {
        level: '4',
        code: '1103-1',
        label: 'Northern Cheyenne',
        description: 'Northern Cheyenne'
    },
    {
        level: '4',
        code: '1104-9',
        label: 'Southern Cheyenne',
        description: 'Southern Cheyenne'
    },
    {
        level: '4',
        code: '1106-4',
        label: 'Cheyenne-Arapaho',
        description: 'Cheyenne-Arapaho'
    },
    {
        level: '4',
        code: '1108-0',
        label: 'Chickahominy',
        description: 'Chickahominy'
    },
    {
        level: '4',
        code: '1109-8',
        label: 'Eastern Chickahominy',
        description: 'Eastern Chickahominy'
    },
    {
        level: '4',
        code: '1110-6',
        label: 'Western Chickahominy',
        description: 'Western Chickahominy'
    },
    {
        level: '4',
        code: '1112-2',
        label: 'Chickasaw',
        description: 'Chickasaw'
    },
    { level: '4', code: '1114-8', label: 'Chinook', description: 'Chinook' },
    { level: '4', code: '1115-5', label: 'Clatsop', description: 'Clatsop' },
    {
        level: '4',
        code: '1116-3',
        label: 'Columbia River Chinook',
        description: 'Columbia River Chinook'
    },
    {
        level: '4',
        code: '1117-1',
        label: 'Kathlamet',
        description: 'Kathlamet'
    },
    {
        level: '4',
        code: '1118-9',
        label: 'Upper Chinook',
        description: 'Upper Chinook'
    },
    {
        level: '4',
        code: '1119-7',
        label: 'Wakiakum Chinook',
        description: 'Wakiakum Chinook'
    },
    {
        level: '4',
        code: '1120-5',
        label: 'Willapa Chinook',
        description: 'Willapa Chinook'
    },
    { level: '4', code: '1121-3', label: 'Wishram', description: 'Wishram' },
    { level: '4', code: '1123-9', label: 'Chippewa', description: 'Chippewa' },
    {
        level: '4',
        code: '1124-7',
        label: 'Bad River',
        description: 'Bad River'
    },
    {
        level: '4',
        code: '1125-4',
        label: 'Bay Mills Chippewa',
        description: 'Bay Mills Chippewa'
    },
    {
        level: '4',
        code: '1126-2',
        label: 'Bois Forte',
        description: 'Bois Forte'
    },
    {
        level: '4',
        code: '1127-0',
        label: 'Burt Lake Chippewa',
        description: 'Burt Lake Chippewa'
    },
    {
        level: '4',
        code: '1128-8',
        label: 'Fond du Lac',
        description: 'Fond du Lac'
    },
    {
        level: '4',
        code: '1129-6',
        label: 'Grand Portage',
        description: 'Grand Portage'
    },
    {
        level: '4',
        code: '1130-4',
        label: 'Grand Traverse Band of Ottawa-Chippewa',
        description: 'Grand Traverse Band of Ottawa-Chippewa'
    },
    { level: '4', code: '1131-2', label: 'Keweenaw', description: 'Keweenaw' },
    {
        level: '4',
        code: '1132-0',
        label: 'Lac Courte Oreilles',
        description: 'Lac Courte Oreilles'
    },
    {
        level: '4',
        code: '1133-8',
        label: 'Lac du Flambeau',
        description: 'Lac du Flambeau'
    },
    {
        level: '4',
        code: '1134-6',
        label: 'Lac Vieux Desert Chippewa',
        description: 'Lac Vieux Desert Chippewa'
    },
    {
        level: '4',
        code: '1135-3',
        label: 'Lake Superior',
        description: 'Lake Superior'
    },
    {
        level: '4',
        code: '1136-1',
        label: 'Leech Lake',
        description: 'Leech Lake'
    },
    {
        level: '4',
        code: '1137-9',
        label: 'Little Shell Chippewa',
        description: 'Little Shell Chippewa'
    },
    {
        level: '4',
        code: '1138-7',
        label: 'Mille Lacs',
        description: 'Mille Lacs'
    },
    {
        level: '4',
        code: '1139-5',
        label: 'Minnesota Chippewa',
        description: 'Minnesota Chippewa'
    },
    {
        level: '4',
        code: '1140-3',
        label: 'Ontonagon',
        description: 'Ontonagon'
    },
    {
        level: '4',
        code: '1141-1',
        label: 'Red Cliff Chippewa',
        description: 'Red Cliff Chippewa'
    },
    {
        level: '4',
        code: '1142-9',
        label: 'Red Lake Chippewa',
        description: 'Red Lake Chippewa'
    },
    {
        level: '4',
        code: '1143-7',
        label: 'Saginaw Chippewa',
        description: 'Saginaw Chippewa'
    },
    {
        level: '4',
        code: '1144-5',
        label: 'St. Croix Chippewa',
        description: 'St. Croix Chippewa'
    },
    {
        level: '4',
        code: '1145-2',
        label: 'Sault Ste. Marie Chippewa',
        description: 'Sault Ste. Marie Chippewa'
    },
    {
        level: '4',
        code: '1146-0',
        label: 'Sokoagon Chippewa',
        description: 'Sokoagon Chippewa'
    },
    {
        level: '4',
        code: '1147-8',
        label: 'Turtle Mountain',
        description: 'Turtle Mountain'
    },
    {
        level: '4',
        code: '1148-6',
        label: 'White Earth',
        description: 'White Earth'
    },
    {
        level: '4',
        code: '1150-2',
        label: 'Chippewa Cree',
        description: 'Chippewa Cree'
    },
    {
        level: '4',
        code: '1151-0',
        label: "Rocky Boy's Chippewa Cree",
        description: "Rocky Boy's Chippewa Cree"
    },
    {
        level: '4',
        code: '1153-6',
        label: 'Chitimacha',
        description: 'Chitimacha'
    },
    { level: '4', code: '1155-1', label: 'Choctaw', description: 'Choctaw' },
    {
        level: '4',
        code: '1156-9',
        label: 'Clifton Choctaw',
        description: 'Clifton Choctaw'
    },
    {
        level: '4',
        code: '1157-7',
        label: 'Jena Choctaw',
        description: 'Jena Choctaw'
    },
    {
        level: '4',
        code: '1158-5',
        label: 'Mississippi Choctaw',
        description: 'Mississippi Choctaw'
    },
    {
        level: '4',
        code: '1159-3',
        label: 'Mowa Band of Choctaw',
        description: 'Mowa Band of Choctaw'
    },
    {
        level: '4',
        code: '1160-1',
        label: 'Oklahoma Choctaw',
        description: 'Oklahoma Choctaw'
    },
    { level: '4', code: '1162-7', label: 'Chumash', description: 'Chumash' },
    {
        level: '4',
        code: '1163-5',
        label: 'Santa Ynez',
        description: 'Santa Ynez'
    },
    {
        level: '4',
        code: '1165-0',
        label: 'Clear Lake',
        description: 'Clear Lake'
    },
    {
        level: '4',
        code: '1167-6',
        label: "Coeur D'Alene",
        description: "Coeur D'Alene"
    },
    { level: '4', code: '1169-2', label: 'Coharie', description: 'Coharie' },
    {
        level: '4',
        code: '1171-8',
        label: 'Colorado River',
        description: 'Colorado River'
    },
    { level: '4', code: '1173-4', label: 'Colville', description: 'Colville' },
    { level: '4', code: '1175-9', label: 'Comanche', description: 'Comanche' },
    {
        level: '4',
        code: '1176-7',
        label: 'Oklahoma Comanche',
        description: 'Oklahoma Comanche'
    },
    {
        level: '4',
        code: '1178-3',
        label: 'Coos, Lower Umpqua, Siuslaw',
        description: 'Coos, Lower Umpqua, Siuslaw'
    },
    { level: '4', code: '1180-9', label: 'Coos', description: 'Coos' },
    {
        level: '4',
        code: '1182-5',
        label: 'Coquilles',
        description: 'Coquilles'
    },
    {
        level: '4',
        code: '1184-1',
        label: 'Costanoan',
        description: 'Costanoan'
    },
    {
        level: '4',
        code: '1186-6',
        label: 'Coushatta',
        description: 'Coushatta'
    },
    {
        level: '4',
        code: '1187-4',
        label: 'Alabama Coushatta',
        description: 'Alabama Coushatta'
    },
    { level: '4', code: '1189-0', label: 'Cowlitz', description: 'Cowlitz' },
    { level: '4', code: '1191-6', label: 'Cree', description: 'Cree' },
    { level: '4', code: '1193-2', label: 'Creek', description: 'Creek' },
    {
        level: '4',
        code: '1194-0',
        label: 'Alabama Creek',
        description: 'Alabama Creek'
    },
    {
        level: '4',
        code: '1195-7',
        label: 'Alabama Quassarte',
        description: 'Alabama Quassarte'
    },
    {
        level: '4',
        code: '1196-5',
        label: 'Eastern Creek',
        description: 'Eastern Creek'
    },
    {
        level: '4',
        code: '1197-3',
        label: 'Eastern Muscogee',
        description: 'Eastern Muscogee'
    },
    { level: '4', code: '1198-1', label: 'Kialegee', description: 'Kialegee' },
    {
        level: '4',
        code: '1199-9',
        label: 'Lower Muscogee',
        description: 'Lower Muscogee'
    },
    {
        level: '4',
        code: '1200-5',
        label: 'Machis Lower Creek Indian',
        description: 'Machis Lower Creek Indian'
    },
    {
        level: '4',
        code: '1201-3',
        label: 'Poarch Band',
        description: 'Poarch Band'
    },
    {
        level: '4',
        code: '1202-1',
        label: 'Principal Creek Indian Nation',
        description: 'Principal Creek Indian Nation'
    },
    {
        level: '4',
        code: '1203-9',
        label: 'Star Clan of Muscogee Creeks',
        description: 'Star Clan of Muscogee Creeks'
    },
    {
        level: '4',
        code: '1204-7',
        label: 'Thlopthlocco',
        description: 'Thlopthlocco'
    },
    {
        level: '4',
        code: '1205-4',
        label: 'Tuckabachee',
        description: 'Tuckabachee'
    },
    { level: '4', code: '1207-0', label: 'Croatan', description: 'Croatan' },
    { level: '4', code: '1209-6', label: 'Crow', description: 'Crow' },
    { level: '4', code: '1211-2', label: 'Cupeno', description: 'Cupeno' },
    {
        level: '4',
        code: '1212-0',
        label: 'Agua Caliente',
        description: 'Agua Caliente'
    },
    { level: '4', code: '1214-6', label: 'Delaware', description: 'Delaware' },
    {
        level: '4',
        code: '1215-3',
        label: 'Eastern Delaware',
        description: 'Eastern Delaware'
    },
    {
        level: '4',
        code: '1216-1',
        label: 'Lenni-Lenape',
        description: 'Lenni-Lenape'
    },
    { level: '4', code: '1217-9', label: 'Munsee', description: 'Munsee' },
    {
        level: '4',
        code: '1218-7',
        label: 'Oklahoma Delaware',
        description: 'Oklahoma Delaware'
    },
    {
        level: '4',
        code: '1219-5',
        label: 'Rampough Mountain',
        description: 'Rampough Mountain'
    },
    {
        level: '4',
        code: '1220-3',
        label: 'Sand Hill',
        description: 'Sand Hill'
    },
    { level: '4', code: '1222-9', label: 'Diegueno', description: 'Diegueno' },
    { level: '4', code: '1223-7', label: 'Campo', description: 'Campo' },
    {
        level: '4',
        code: '1224-5',
        label: 'Capitan Grande',
        description: 'Capitan Grande'
    },
    {
        level: '4',
        code: '1225-2',
        label: 'Cuyapaipe',
        description: 'Cuyapaipe'
    },
    { level: '4', code: '1226-0', label: 'La Posta', description: 'La Posta' },
    {
        level: '4',
        code: '1227-8',
        label: 'Manzanita',
        description: 'Manzanita'
    },
    {
        level: '4',
        code: '1228-6',
        label: 'Mesa Grande',
        description: 'Mesa Grande'
    },
    {
        level: '4',
        code: '1229-4',
        label: 'San Pasqual',
        description: 'San Pasqual'
    },
    {
        level: '4',
        code: '1230-2',
        label: 'Santa Ysabel',
        description: 'Santa Ysabel'
    },
    { level: '4', code: '1231-0', label: 'Sycuan', description: 'Sycuan' },
    {
        level: '4',
        code: '1233-6',
        label: 'Eastern Tribes',
        description: 'Eastern Tribes'
    },
    { level: '4', code: '1234-4', label: 'Attacapa', description: 'Attacapa' },
    { level: '4', code: '1235-1', label: 'Biloxi', description: 'Biloxi' },
    {
        level: '4',
        code: '1236-9',
        label: 'Georgetown',
        description: 'Georgetown'
    },
    { level: '4', code: '1237-7', label: 'Moor', description: 'Moor' },
    {
        level: '4',
        code: '1238-5',
        label: 'Nansemond',
        description: 'Nansemond'
    },
    { level: '4', code: '1239-3', label: 'Natchez', description: 'Natchez' },
    {
        level: '4',
        code: '1240-1',
        label: 'Nausu Waiwash',
        description: 'Nausu Waiwash'
    },
    { level: '4', code: '1241-9', label: 'Nipmuc', description: 'Nipmuc' },
    {
        level: '4',
        code: '1242-7',
        label: 'Paugussett',
        description: 'Paugussett'
    },
    {
        level: '4',
        code: '1243-5',
        label: 'Pocomoke Acohonock',
        description: 'Pocomoke Acohonock'
    },
    {
        level: '4',
        code: '1244-3',
        label: 'Southeastern Indians',
        description: 'Southeastern Indians'
    },
    {
        level: '4',
        code: '1245-0',
        label: 'Susquehanock',
        description: 'Susquehanock'
    },
    {
        level: '4',
        code: '1246-8',
        label: 'Tunica Biloxi',
        description: 'Tunica Biloxi'
    },
    {
        level: '4',
        code: '1247-6',
        label: 'Waccamaw-Siousan',
        description: 'Waccamaw-Siousan'
    },
    { level: '4', code: '1248-4', label: 'Wicomico', description: 'Wicomico' },
    { level: '4', code: '1250-0', label: 'Esselen', description: 'Esselen' },
    {
        level: '4',
        code: '1252-6',
        label: 'Fort Belknap',
        description: 'Fort Belknap'
    },
    {
        level: '4',
        code: '1254-2',
        label: 'Fort Berthold',
        description: 'Fort Berthold'
    },
    {
        level: '4',
        code: '1256-7',
        label: 'Fort Mcdowell',
        description: 'Fort Mcdowell'
    },
    {
        level: '4',
        code: '1258-3',
        label: 'Fort Hall',
        description: 'Fort Hall'
    },
    {
        level: '4',
        code: '1260-9',
        label: 'Gabrieleno',
        description: 'Gabrieleno'
    },
    {
        level: '4',
        code: '1262-5',
        label: 'Grand Ronde',
        description: 'Grand Ronde'
    },
    {
        level: '4',
        code: '1264-1',
        label: 'Gros Ventres',
        description: 'Gros Ventres'
    },
    { level: '4', code: '1265-8', label: 'Atsina', description: 'Atsina' },
    { level: '4', code: '1267-4', label: 'Haliwa', description: 'Haliwa' },
    { level: '4', code: '1269-0', label: 'Hidatsa', description: 'Hidatsa' },
    { level: '4', code: '1271-6', label: 'Hoopa', description: 'Hoopa' },
    { level: '4', code: '1272-4', label: 'Trinity', description: 'Trinity' },
    { level: '4', code: '1273-2', label: 'Whilkut', description: 'Whilkut' },
    {
        level: '4',
        code: '1275-7',
        label: 'Hoopa Extension',
        description: 'Hoopa Extension'
    },
    { level: '4', code: '1277-3', label: 'Houma', description: 'Houma' },
    {
        level: '4',
        code: '1279-9',
        label: 'Inaja-Cosmit',
        description: 'Inaja-Cosmit'
    },
    { level: '4', code: '1281-5', label: 'Iowa', description: 'Iowa' },
    {
        level: '4',
        code: '1282-3',
        label: 'Iowa of Kansas-Nebraska',
        description: 'Iowa of Kansas-Nebraska'
    },
    {
        level: '4',
        code: '1283-1',
        label: 'Iowa of Oklahoma',
        description: 'Iowa of Oklahoma'
    },
    { level: '4', code: '1285-6', label: 'Iroquois', description: 'Iroquois' },
    { level: '4', code: '1286-4', label: 'Cayuga', description: 'Cayuga' },
    { level: '4', code: '1287-2', label: 'Mohawk', description: 'Mohawk' },
    { level: '4', code: '1288-0', label: 'Oneida', description: 'Oneida' },
    { level: '4', code: '1289-8', label: 'Onondaga', description: 'Onondaga' },
    { level: '4', code: '1290-6', label: 'Seneca', description: 'Seneca' },
    {
        level: '4',
        code: '1291-4',
        label: 'Seneca Nation',
        description: 'Seneca Nation'
    },
    {
        level: '4',
        code: '1292-2',
        label: 'Seneca-Cayuga',
        description: 'Seneca-Cayuga'
    },
    {
        level: '4',
        code: '1293-0',
        label: 'Tonawanda Seneca',
        description: 'Tonawanda Seneca'
    },
    {
        level: '4',
        code: '1294-8',
        label: 'Tuscarora',
        description: 'Tuscarora'
    },
    {
        level: '4',
        code: '1295-5',
        label: 'Wyandotte',
        description: 'Wyandotte'
    },
    { level: '4', code: '1297-1', label: 'Juaneno', description: 'Juaneno' },
    { level: '4', code: '1299-7', label: 'Kalispel', description: 'Kalispel' },
    { level: '4', code: '1301-1', label: 'Karuk', description: 'Karuk' },
    { level: '4', code: '1303-7', label: 'Kaw', description: 'Kaw' },
    { level: '4', code: '1305-2', label: 'Kickapoo', description: 'Kickapoo' },
    {
        level: '4',
        code: '1306-0',
        label: 'Oklahoma Kickapoo',
        description: 'Oklahoma Kickapoo'
    },
    {
        level: '4',
        code: '1307-8',
        label: 'Texas Kickapoo',
        description: 'Texas Kickapoo'
    },
    { level: '4', code: '1309-4', label: 'Kiowa', description: 'Kiowa' },
    {
        level: '4',
        code: '1310-2',
        label: 'Oklahoma Kiowa',
        description: 'Oklahoma Kiowa'
    },
    { level: '4', code: '1312-8', label: 'Klallam', description: 'Klallam' },
    {
        level: '4',
        code: '1313-6',
        label: 'Jamestown',
        description: 'Jamestown'
    },
    {
        level: '4',
        code: '1314-4',
        label: 'Lower Elwha',
        description: 'Lower Elwha'
    },
    {
        level: '4',
        code: '1315-1',
        label: 'Port Gamble Klallam',
        description: 'Port Gamble Klallam'
    },
    { level: '4', code: '1317-7', label: 'Klamath', description: 'Klamath' },
    { level: '4', code: '1319-3', label: 'Konkow', description: 'Konkow' },
    { level: '4', code: '1321-9', label: 'Kootenai', description: 'Kootenai' },
    { level: '4', code: '1323-5', label: 'Lassik', description: 'Lassik' },
    {
        level: '4',
        code: '1325-0',
        label: 'Long Island',
        description: 'Long Island'
    },
    {
        level: '4',
        code: '1326-8',
        label: 'Matinecock',
        description: 'Matinecock'
    },
    { level: '4', code: '1327-6', label: 'Montauk', description: 'Montauk' },
    {
        level: '4',
        code: '1328-4',
        label: 'Poospatuck',
        description: 'Poospatuck'
    },
    { level: '4', code: '1329-2', label: 'Setauket', description: 'Setauket' },
    { level: '4', code: '1331-8', label: 'Luiseno', description: 'Luiseno' },
    { level: '4', code: '1332-6', label: 'La Jolla', description: 'La Jolla' },
    { level: '4', code: '1333-4', label: 'Pala', description: 'Pala' },
    { level: '4', code: '1334-2', label: 'Pauma', description: 'Pauma' },
    { level: '4', code: '1335-9', label: 'Pechanga', description: 'Pechanga' },
    { level: '4', code: '1336-7', label: 'Soboba', description: 'Soboba' },
    {
        level: '4',
        code: '1337-5',
        label: 'Twenty-Nine Palms',
        description: 'Twenty-Nine Palms'
    },
    { level: '4', code: '1338-3', label: 'Temecula', description: 'Temecula' },
    { level: '4', code: '1340-9', label: 'Lumbee', description: 'Lumbee' },
    { level: '4', code: '1342-5', label: 'Lummi', description: 'Lummi' },
    { level: '4', code: '1344-1', label: 'Maidu', description: 'Maidu' },
    {
        level: '4',
        code: '1345-8',
        label: 'Mountain Maidu',
        description: 'Mountain Maidu'
    },
    { level: '4', code: '1346-6', label: 'Nishinam', description: 'Nishinam' },
    { level: '4', code: '1348-2', label: 'Makah', description: 'Makah' },
    { level: '4', code: '1350-8', label: 'Maliseet', description: 'Maliseet' },
    { level: '4', code: '1352-4', label: 'Mandan', description: 'Mandan' },
    {
        level: '4',
        code: '1354-0',
        label: 'Mattaponi',
        description: 'Mattaponi'
    },
    {
        level: '4',
        code: '1356-5',
        label: 'Menominee',
        description: 'Menominee'
    },
    { level: '4', code: '1358-1', label: 'Miami', description: 'Miami' },
    {
        level: '4',
        code: '1359-9',
        label: 'Illinois Miami',
        description: 'Illinois Miami'
    },
    {
        level: '4',
        code: '1360-7',
        label: 'Indiana Miami',
        description: 'Indiana Miami'
    },
    {
        level: '4',
        code: '1361-5',
        label: 'Oklahoma Miami',
        description: 'Oklahoma Miami'
    },
    {
        level: '4',
        code: '1363-1',
        label: 'Miccosukee',
        description: 'Miccosukee'
    },
    { level: '4', code: '1365-6', label: 'Micmac', description: 'Micmac' },
    {
        level: '4',
        code: '1366-4',
        label: 'Aroostook',
        description: 'Aroostook'
    },
    {
        level: '4',
        code: '1368-0',
        label: 'Mission Indians',
        description: 'Mission Indians'
    },
    { level: '4', code: '1370-6', label: 'Miwok', description: 'Miwok' },
    { level: '4', code: '1372-2', label: 'Modoc', description: 'Modoc' },
    { level: '4', code: '1374-8', label: 'Mohegan', description: 'Mohegan' },
    { level: '4', code: '1376-3', label: 'Mono', description: 'Mono' },
    {
        level: '4',
        code: '1378-9',
        label: 'Nanticoke',
        description: 'Nanticoke'
    },
    {
        level: '4',
        code: '1380-5',
        label: 'Narragansett',
        description: 'Narragansett'
    },
    { level: '4', code: '1382-1', label: 'Navajo', description: 'Navajo' },
    {
        level: '4',
        code: '1383-9',
        label: 'Alamo Navajo',
        description: 'Alamo Navajo'
    },
    {
        level: '4',
        code: '1384-7',
        label: 'Canoncito Navajo',
        description: 'Canoncito Navajo'
    },
    {
        level: '4',
        code: '1385-4',
        label: 'Ramah Navajo',
        description: 'Ramah Navajo'
    },
    {
        level: '4',
        code: '1387-0',
        label: 'Nez Perce',
        description: 'Nez Perce'
    },
    { level: '4', code: '1389-6', label: 'Nomalaki', description: 'Nomalaki' },
    {
        level: '4',
        code: '1391-2',
        label: 'Northwest Tribes',
        description: 'Northwest Tribes'
    },
    { level: '4', code: '1392-0', label: 'Alsea', description: 'Alsea' },
    { level: '4', code: '1393-8', label: 'Celilo', description: 'Celilo' },
    { level: '4', code: '1394-6', label: 'Columbia', description: 'Columbia' },
    { level: '4', code: '1395-3', label: 'Kalapuya', description: 'Kalapuya' },
    { level: '4', code: '1396-1', label: 'Molala', description: 'Molala' },
    {
        level: '4',
        code: '1397-9',
        label: 'Talakamish',
        description: 'Talakamish'
    },
    { level: '4', code: '1398-7', label: 'Tenino', description: 'Tenino' },
    {
        level: '4',
        code: '1399-5',
        label: 'Tillamook',
        description: 'Tillamook'
    },
    {
        level: '4',
        code: '1400-1',
        label: 'Wenatchee',
        description: 'Wenatchee'
    },
    {
        level: '4',
        code: '1401-9',
        label: 'Yahooskin',
        description: 'Yahooskin'
    },
    { level: '4', code: '1403-5', label: 'Omaha', description: 'Omaha' },
    {
        level: '4',
        code: '1405-0',
        label: 'Oregon Athabaskan',
        description: 'Oregon Athabaskan'
    },
    { level: '4', code: '1407-6', label: 'Osage', description: 'Osage' },
    {
        level: '4',
        code: '1409-2',
        label: 'Otoe-Missouria',
        description: 'Otoe-Missouria'
    },
    { level: '4', code: '1411-8', label: 'Ottawa', description: 'Ottawa' },
    {
        level: '4',
        code: '1412-6',
        label: 'Burt Lake Ottawa',
        description: 'Burt Lake Ottawa'
    },
    {
        level: '4',
        code: '1413-4',
        label: 'Michigan Ottawa',
        description: 'Michigan Ottawa'
    },
    {
        level: '4',
        code: '1414-2',
        label: 'Oklahoma Ottawa',
        description: 'Oklahoma Ottawa'
    },
    { level: '4', code: '1416-7', label: 'Paiute', description: 'Paiute' },
    { level: '4', code: '1417-5', label: 'Bishop', description: 'Bishop' },
    {
        level: '4',
        code: '1418-3',
        label: 'Bridgeport',
        description: 'Bridgeport'
    },
    {
        level: '4',
        code: '1419-1',
        label: 'Burns Paiute',
        description: 'Burns Paiute'
    },
    {
        level: '4',
        code: '1420-9',
        label: 'Cedarville',
        description: 'Cedarville'
    },
    {
        level: '4',
        code: '1421-7',
        label: 'Fort Bidwell',
        description: 'Fort Bidwell'
    },
    {
        level: '4',
        code: '1422-5',
        label: 'Fort Independence',
        description: 'Fort Independence'
    },
    { level: '4', code: '1423-3', label: 'Kaibab', description: 'Kaibab' },
    {
        level: '4',
        code: '1424-1',
        label: 'Las Vegas',
        description: 'Las Vegas'
    },
    {
        level: '4',
        code: '1425-8',
        label: 'Lone Pine',
        description: 'Lone Pine'
    },
    { level: '4', code: '1426-6', label: 'Lovelock', description: 'Lovelock' },
    {
        level: '4',
        code: '1427-4',
        label: 'Malheur Paiute',
        description: 'Malheur Paiute'
    },
    { level: '4', code: '1428-2', label: 'Moapa', description: 'Moapa' },
    {
        level: '4',
        code: '1429-0',
        label: 'Northern Paiute',
        description: 'Northern Paiute'
    },
    {
        level: '4',
        code: '1430-8',
        label: 'Owens Valley',
        description: 'Owens Valley'
    },
    {
        level: '4',
        code: '1431-6',
        label: 'Pyramid Lake',
        description: 'Pyramid Lake'
    },
    {
        level: '4',
        code: '1432-4',
        label: 'San Juan Southern Paiute',
        description: 'San Juan Southern Paiute'
    },
    {
        level: '4',
        code: '1433-2',
        label: 'Southern Paiute',
        description: 'Southern Paiute'
    },
    {
        level: '4',
        code: '1434-0',
        label: 'Summit Lake',
        description: 'Summit Lake'
    },
    {
        level: '4',
        code: '1435-7',
        label: 'Utu Utu Gwaitu Paiute',
        description: 'Utu Utu Gwaitu Paiute'
    },
    {
        level: '4',
        code: '1436-5',
        label: 'Walker River',
        description: 'Walker River'
    },
    {
        level: '4',
        code: '1437-3',
        label: 'Yerington Paiute',
        description: 'Yerington Paiute'
    },
    { level: '4', code: '1439-9', label: 'Pamunkey', description: 'Pamunkey' },
    {
        level: '4',
        code: '1441-5',
        label: 'Passamaquoddy',
        description: 'Passamaquoddy'
    },
    {
        level: '4',
        code: '1442-3',
        label: 'Indian Township',
        description: 'Indian Township'
    },
    {
        level: '4',
        code: '1443-1',
        label: 'Pleasant Point Passamaquoddy',
        description: 'Pleasant Point Passamaquoddy'
    },
    { level: '4', code: '1445-6', label: 'Pawnee', description: 'Pawnee' },
    {
        level: '4',
        code: '1446-4',
        label: 'Oklahoma Pawnee',
        description: 'Oklahoma Pawnee'
    },
    {
        level: '4',
        code: '1448-0',
        label: 'Penobscot',
        description: 'Penobscot'
    },
    { level: '4', code: '1450-6', label: 'Peoria', description: 'Peoria' },
    {
        level: '4',
        code: '1451-4',
        label: 'Oklahoma Peoria',
        description: 'Oklahoma Peoria'
    },
    { level: '4', code: '1453-0', label: 'Pequot', description: 'Pequot' },
    {
        level: '4',
        code: '1454-8',
        label: 'Marshantucket Pequot',
        description: 'Marshantucket Pequot'
    },
    { level: '4', code: '1456-3', label: 'Pima', description: 'Pima' },
    {
        level: '4',
        code: '1457-1',
        label: 'Gila River Pima-Maricopa',
        description: 'Gila River Pima-Maricopa'
    },
    {
        level: '4',
        code: '1458-9',
        label: 'Salt River Pima-Maricopa',
        description: 'Salt River Pima-Maricopa'
    },
    {
        level: '4',
        code: '1460-5',
        label: 'Piscataway',
        description: 'Piscataway'
    },
    {
        level: '4',
        code: '1462-1',
        label: 'Pit River',
        description: 'Pit River'
    },
    { level: '4', code: '1464-7', label: 'Pomo', description: 'Pomo' },
    {
        level: '4',
        code: '1465-4',
        label: 'Central Pomo',
        description: 'Central Pomo'
    },
    {
        level: '4',
        code: '1466-2',
        label: 'Dry Creek',
        description: 'Dry Creek'
    },
    {
        level: '4',
        code: '1467-0',
        label: 'Eastern Pomo',
        description: 'Eastern Pomo'
    },
    { level: '4', code: '1468-8', label: 'Kashia', description: 'Kashia' },
    {
        level: '4',
        code: '1469-6',
        label: 'Northern Pomo',
        description: 'Northern Pomo'
    },
    {
        level: '4',
        code: '1470-4',
        label: 'Scotts Valley',
        description: 'Scotts Valley'
    },
    {
        level: '4',
        code: '1471-2',
        label: 'Stonyford',
        description: 'Stonyford'
    },
    {
        level: '4',
        code: '1472-0',
        label: 'Sulphur Bank',
        description: 'Sulphur Bank'
    },
    { level: '4', code: '1474-6', label: 'Ponca', description: 'Ponca' },
    {
        level: '4',
        code: '1475-3',
        label: 'Nebraska Ponca',
        description: 'Nebraska Ponca'
    },
    {
        level: '4',
        code: '1476-1',
        label: 'Oklahoma Ponca',
        description: 'Oklahoma Ponca'
    },
    {
        level: '4',
        code: '1478-7',
        label: 'Potawatomi',
        description: 'Potawatomi'
    },
    {
        level: '4',
        code: '1479-5',
        label: 'Citizen Band Potawatomi',
        description: 'Citizen Band Potawatomi'
    },
    {
        level: '4',
        code: '1480-3',
        label: 'Forest County',
        description: 'Forest County'
    },
    {
        level: '4',
        code: '1481-1',
        label: 'Hannahville',
        description: 'Hannahville'
    },
    {
        level: '4',
        code: '1482-9',
        label: 'Huron Potawatomi',
        description: 'Huron Potawatomi'
    },
    {
        level: '4',
        code: '1483-7',
        label: 'Pokagon Potawatomi',
        description: 'Pokagon Potawatomi'
    },
    {
        level: '4',
        code: '1484-5',
        label: 'Prairie Band',
        description: 'Prairie Band'
    },
    {
        level: '4',
        code: '1485-2',
        label: 'Wisconsin Potawatomi',
        description: 'Wisconsin Potawatomi'
    },
    { level: '4', code: '1487-8', label: 'Powhatan', description: 'Powhatan' },
    { level: '4', code: '1489-4', label: 'Pueblo', description: 'Pueblo' },
    { level: '4', code: '1490-2', label: 'Acoma', description: 'Acoma' },
    {
        level: '4',
        code: '1491-0',
        label: 'Arizona Tewa',
        description: 'Arizona Tewa'
    },
    { level: '4', code: '1492-8', label: 'Cochiti', description: 'Cochiti' },
    { level: '4', code: '1493-6', label: 'Hopi', description: 'Hopi' },
    { level: '4', code: '1494-4', label: 'Isleta', description: 'Isleta' },
    { level: '4', code: '1495-1', label: 'Jemez', description: 'Jemez' },
    { level: '4', code: '1496-9', label: 'Keres', description: 'Keres' },
    { level: '4', code: '1497-7', label: 'Laguna', description: 'Laguna' },
    { level: '4', code: '1498-5', label: 'Nambe', description: 'Nambe' },
    { level: '4', code: '1499-3', label: 'Picuris', description: 'Picuris' },
    { level: '4', code: '1500-8', label: 'Piro', description: 'Piro' },
    { level: '4', code: '1501-6', label: 'Pojoaque', description: 'Pojoaque' },
    {
        level: '4',
        code: '1502-4',
        label: 'San Felipe',
        description: 'San Felipe'
    },
    {
        level: '4',
        code: '1503-2',
        label: 'San Ildefonso',
        description: 'San Ildefonso'
    },
    {
        level: '4',
        code: '1504-0',
        label: 'San Juan Pueblo',
        description: 'San Juan Pueblo'
    },
    {
        level: '4',
        code: '1505-7',
        label: 'San Juan De',
        description: 'San Juan De'
    },
    { level: '4', code: '1506-5', label: 'San Juan', description: 'San Juan' },
    { level: '4', code: '1507-3', label: 'Sandia', description: 'Sandia' },
    {
        level: '4',
        code: '1508-1',
        label: 'Santa Ana',
        description: 'Santa Ana'
    },
    {
        level: '4',
        code: '1509-9',
        label: 'Santa Clara',
        description: 'Santa Clara'
    },
    {
        level: '4',
        code: '1510-7',
        label: 'Santo Domingo',
        description: 'Santo Domingo'
    },
    { level: '4', code: '1511-5', label: 'Taos', description: 'Taos' },
    { level: '4', code: '1512-3', label: 'Tesuque', description: 'Tesuque' },
    { level: '4', code: '1513-1', label: 'Tewa', description: 'Tewa' },
    { level: '4', code: '1514-9', label: 'Tigua', description: 'Tigua' },
    { level: '4', code: '1515-6', label: 'Zia', description: 'Zia' },
    { level: '4', code: '1516-4', label: 'Zuni', description: 'Zuni' },
    {
        level: '4',
        code: '1518-0',
        label: 'Puget Sound Salish',
        description: 'Puget Sound Salish'
    },
    { level: '4', code: '1519-8', label: 'Duwamish', description: 'Duwamish' },
    {
        level: '4',
        code: '1520-6',
        label: 'Kikiallus',
        description: 'Kikiallus'
    },
    {
        level: '4',
        code: '1521-4',
        label: 'Lower Skagit',
        description: 'Lower Skagit'
    },
    {
        level: '4',
        code: '1522-2',
        label: 'Muckleshoot',
        description: 'Muckleshoot'
    },
    {
        level: '4',
        code: '1523-0',
        label: 'Nisqually',
        description: 'Nisqually'
    },
    { level: '4', code: '1524-8', label: 'Nooksack', description: 'Nooksack' },
    {
        level: '4',
        code: '1525-5',
        label: 'Port Madison',
        description: 'Port Madison'
    },
    { level: '4', code: '1526-3', label: 'Puyallup', description: 'Puyallup' },
    { level: '4', code: '1527-1', label: 'Samish', description: 'Samish' },
    {
        level: '4',
        code: '1528-9',
        label: 'Sauk-Suiattle',
        description: 'Sauk-Suiattle'
    },
    {
        level: '4',
        code: '1529-7',
        label: 'Skokomish',
        description: 'Skokomish'
    },
    {
        level: '4',
        code: '1530-5',
        label: 'Skykomish',
        description: 'Skykomish'
    },
    {
        level: '4',
        code: '1531-3',
        label: 'Snohomish',
        description: 'Snohomish'
    },
    {
        level: '4',
        code: '1532-1',
        label: 'Snoqualmie',
        description: 'Snoqualmie'
    },
    {
        level: '4',
        code: '1533-9',
        label: 'Squaxin Island',
        description: 'Squaxin Island'
    },
    {
        level: '4',
        code: '1534-7',
        label: 'Steilacoom',
        description: 'Steilacoom'
    },
    {
        level: '4',
        code: '1535-4',
        label: 'Stillaguamish',
        description: 'Stillaguamish'
    },
    {
        level: '4',
        code: '1536-2',
        label: 'Suquamish',
        description: 'Suquamish'
    },
    {
        level: '4',
        code: '1537-0',
        label: 'Swinomish',
        description: 'Swinomish'
    },
    { level: '4', code: '1538-8', label: 'Tulalip', description: 'Tulalip' },
    {
        level: '4',
        code: '1539-6',
        label: 'Upper Skagit',
        description: 'Upper Skagit'
    },
    { level: '4', code: '1541-2', label: 'Quapaw', description: 'Quapaw' },
    { level: '4', code: '1543-8', label: 'Quinault', description: 'Quinault' },
    {
        level: '4',
        code: '1545-3',
        label: 'Rappahannock',
        description: 'Rappahannock'
    },
    {
        level: '4',
        code: '1547-9',
        label: 'Reno-Sparks',
        description: 'Reno-Sparks'
    },
    {
        level: '4',
        code: '1549-5',
        label: 'Round Valley',
        description: 'Round Valley'
    },
    {
        level: '4',
        code: '1551-1',
        label: 'Sac and Fox',
        description: 'Sac and Fox'
    },
    {
        level: '4',
        code: '1552-9',
        label: 'Iowa Sac and Fox',
        description: 'Iowa Sac and Fox'
    },
    {
        level: '4',
        code: '1553-7',
        label: 'Missouri Sac and Fox',
        description: 'Missouri Sac and Fox'
    },
    {
        level: '4',
        code: '1554-5',
        label: 'Oklahoma Sac and Fox',
        description: 'Oklahoma Sac and Fox'
    },
    { level: '4', code: '1556-0', label: 'Salinan', description: 'Salinan' },
    { level: '4', code: '1558-6', label: 'Salish', description: 'Salish' },
    {
        level: '4',
        code: '1560-2',
        label: 'Salish and Kootenai',
        description: 'Salish and Kootenai'
    },
    {
        level: '4',
        code: '1562-8',
        label: 'Schaghticoke',
        description: 'Schaghticoke'
    },
    {
        level: '4',
        code: '1564-4',
        label: 'Scott Valley',
        description: 'Scott Valley'
    },
    { level: '4', code: '1566-9', label: 'Seminole', description: 'Seminole' },
    {
        level: '4',
        code: '1567-7',
        label: 'Big Cypress',
        description: 'Big Cypress'
    },
    { level: '4', code: '1568-5', label: 'Brighton', description: 'Brighton' },
    {
        level: '4',
        code: '1569-3',
        label: 'Florida Seminole',
        description: 'Florida Seminole'
    },
    {
        level: '4',
        code: '1570-1',
        label: 'Hollywood Seminole',
        description: 'Hollywood Seminole'
    },
    {
        level: '4',
        code: '1571-9',
        label: 'Oklahoma Seminole',
        description: 'Oklahoma Seminole'
    },
    { level: '4', code: '1573-5', label: 'Serrano', description: 'Serrano' },
    {
        level: '4',
        code: '1574-3',
        label: 'San Manual',
        description: 'San Manual'
    },
    { level: '4', code: '1576-8', label: 'Shasta', description: 'Shasta' },
    { level: '4', code: '1578-4', label: 'Shawnee', description: 'Shawnee' },
    {
        level: '4',
        code: '1579-2',
        label: 'Absentee Shawnee',
        description: 'Absentee Shawnee'
    },
    {
        level: '4',
        code: '1580-0',
        label: 'Eastern Shawnee',
        description: 'Eastern Shawnee'
    },
    {
        level: '4',
        code: '1582-6',
        label: 'Shinnecock',
        description: 'Shinnecock'
    },
    {
        level: '4',
        code: '1584-2',
        label: 'Shoalwater Bay',
        description: 'Shoalwater Bay'
    },
    { level: '4', code: '1586-7', label: 'Shoshone', description: 'Shoshone' },
    {
        level: '4',
        code: '1587-5',
        label: 'Battle Mountain',
        description: 'Battle Mountain'
    },
    {
        level: '4',
        code: '1588-3',
        label: 'Duckwater',
        description: 'Duckwater'
    },
    { level: '4', code: '1589-1', label: 'Elko', description: 'Elko' },
    { level: '4', code: '1590-9', label: 'Ely', description: 'Ely' },
    { level: '4', code: '1591-7', label: 'Goshute', description: 'Goshute' },
    { level: '4', code: '1592-5', label: 'Panamint', description: 'Panamint' },
    {
        level: '4',
        code: '1593-3',
        label: 'Ruby Valley',
        description: 'Ruby Valley'
    },
    {
        level: '4',
        code: '1594-1',
        label: 'Skull Valley',
        description: 'Skull Valley'
    },
    {
        level: '4',
        code: '1595-8',
        label: 'South Fork Shoshone',
        description: 'South Fork Shoshone'
    },
    {
        level: '4',
        code: '1596-6',
        label: 'Te-Moak Western Shoshone',
        description: 'Te-Moak Western Shoshone'
    },
    {
        level: '4',
        code: '1597-4',
        label: 'Timbi-Sha Shoshone',
        description: 'Timbi-Sha Shoshone'
    },
    { level: '4', code: '1598-2', label: 'Washakie', description: 'Washakie' },
    {
        level: '4',
        code: '1599-0',
        label: 'Wind River Shoshone',
        description: 'Wind River Shoshone'
    },
    { level: '4', code: '1600-6', label: 'Yomba', description: 'Yomba' },
    {
        level: '4',
        code: '1602-2',
        label: 'Shoshone Paiute',
        description: 'Shoshone Paiute'
    },
    {
        level: '4',
        code: '1603-0',
        label: 'Duck Valley',
        description: 'Duck Valley'
    },
    { level: '4', code: '1604-8', label: 'Fallon', description: 'Fallon' },
    {
        level: '4',
        code: '1605-5',
        label: 'Fort McDermitt',
        description: 'Fort McDermitt'
    },
    { level: '4', code: '1607-1', label: 'Siletz', description: 'Siletz' },
    { level: '4', code: '1609-7', label: 'Sioux', description: 'Sioux' },
    {
        level: '4',
        code: '1610-5',
        label: 'Blackfoot Sioux',
        description: 'Blackfoot Sioux'
    },
    {
        level: '4',
        code: '1611-3',
        label: 'Brule Sioux',
        description: 'Brule Sioux'
    },
    {
        level: '4',
        code: '1612-1',
        label: 'Cheyenne River Sioux',
        description: 'Cheyenne River Sioux'
    },
    {
        level: '4',
        code: '1613-9',
        label: 'Crow Creek Sioux',
        description: 'Crow Creek Sioux'
    },
    {
        level: '4',
        code: '1614-7',
        label: 'Dakota Sioux',
        description: 'Dakota Sioux'
    },
    {
        level: '4',
        code: '1615-4',
        label: 'Flandreau Santee',
        description: 'Flandreau Santee'
    },
    {
        level: '4',
        code: '1616-2',
        label: 'Fort Peck',
        description: 'Fort Peck'
    },
    {
        level: '4',
        code: '1617-0',
        label: 'Lake Traverse Sioux',
        description: 'Lake Traverse Sioux'
    },
    {
        level: '4',
        code: '1618-8',
        label: 'Lower Brule Sioux',
        description: 'Lower Brule Sioux'
    },
    {
        level: '4',
        code: '1619-6',
        label: 'Lower Sioux',
        description: 'Lower Sioux'
    },
    {
        level: '4',
        code: '1620-4',
        label: 'Mdewakanton Sioux',
        description: 'Mdewakanton Sioux'
    },
    {
        level: '4',
        code: '1621-2',
        label: 'Miniconjou',
        description: 'Miniconjou'
    },
    {
        level: '4',
        code: '1622-0',
        label: 'Oglala Sioux',
        description: 'Oglala Sioux'
    },
    {
        level: '4',
        code: '1623-8',
        label: 'Pine Ridge Sioux',
        description: 'Pine Ridge Sioux'
    },
    {
        level: '4',
        code: '1624-6',
        label: 'Pipestone Sioux',
        description: 'Pipestone Sioux'
    },
    {
        level: '4',
        code: '1625-3',
        label: 'Prairie Island Sioux',
        description: 'Prairie Island Sioux'
    },
    {
        level: '4',
        code: '1626-1',
        label: 'Prior Lake Sioux',
        description: 'Prior Lake Sioux'
    },
    {
        level: '4',
        code: '1627-9',
        label: 'Rosebud Sioux',
        description: 'Rosebud Sioux'
    },
    {
        level: '4',
        code: '1628-7',
        label: 'Sans Arc Sioux',
        description: 'Sans Arc Sioux'
    },
    {
        level: '4',
        code: '1629-5',
        label: 'Santee Sioux',
        description: 'Santee Sioux'
    },
    {
        level: '4',
        code: '1630-3',
        label: 'Sisseton-Wahpeton',
        description: 'Sisseton-Wahpeton'
    },
    {
        level: '4',
        code: '1631-1',
        label: 'Sisseton Sioux',
        description: 'Sisseton Sioux'
    },
    {
        level: '4',
        code: '1632-9',
        label: 'Spirit Lake Sioux',
        description: 'Spirit Lake Sioux'
    },
    {
        level: '4',
        code: '1633-7',
        label: 'Standing Rock Sioux',
        description: 'Standing Rock Sioux'
    },
    {
        level: '4',
        code: '1634-5',
        label: 'Teton Sioux',
        description: 'Teton Sioux'
    },
    {
        level: '4',
        code: '1635-2',
        label: 'Two Kettle Sioux',
        description: 'Two Kettle Sioux'
    },
    {
        level: '4',
        code: '1636-0',
        label: 'Upper Sioux',
        description: 'Upper Sioux'
    },
    {
        level: '4',
        code: '1637-8',
        label: 'Wahpekute Sioux',
        description: 'Wahpekute Sioux'
    },
    {
        level: '4',
        code: '1638-6',
        label: 'Wahpeton Sioux',
        description: 'Wahpeton Sioux'
    },
    {
        level: '4',
        code: '1639-4',
        label: 'Wazhaza Sioux',
        description: 'Wazhaza Sioux'
    },
    {
        level: '4',
        code: '1640-2',
        label: 'Yankton Sioux',
        description: 'Yankton Sioux'
    },
    {
        level: '4',
        code: '1641-0',
        label: 'Yanktonai Sioux',
        description: 'Yanktonai Sioux'
    },
    { level: '4', code: '1643-6', label: 'Siuslaw', description: 'Siuslaw' },
    { level: '4', code: '1645-1', label: 'Spokane', description: 'Spokane' },
    { level: '4', code: '1647-7', label: 'Stewart', description: 'Stewart' },
    {
        level: '4',
        code: '1649-3',
        label: 'Stockbridge',
        description: 'Stockbridge'
    },
    {
        level: '4',
        code: '1651-9',
        label: 'Susanville',
        description: 'Susanville'
    },
    {
        level: '4',
        code: '1653-5',
        label: "Tohono O'Odham",
        description: "Tohono O'Odham"
    },
    { level: '4', code: '1654-3', label: 'Ak-Chin', description: 'Ak-Chin' },
    {
        level: '4',
        code: '1655-0',
        label: 'Gila Bend',
        description: 'Gila Bend'
    },
    {
        level: '4',
        code: '1656-8',
        label: 'San Xavier',
        description: 'San Xavier'
    },
    { level: '4', code: '1657-6', label: 'Sells', description: 'Sells' },
    { level: '4', code: '1659-2', label: 'Tolowa', description: 'Tolowa' },
    { level: '4', code: '1661-8', label: 'Tonkawa', description: 'Tonkawa' },
    { level: '4', code: '1663-4', label: 'Tygh', description: 'Tygh' },
    { level: '4', code: '1665-9', label: 'Umatilla', description: 'Umatilla' },
    { level: '4', code: '1667-5', label: 'Umpqua', description: 'Umpqua' },
    {
        level: '4',
        code: '1668-3',
        label: 'Cow Creek Umpqua',
        description: 'Cow Creek Umpqua'
    },
    { level: '4', code: '1670-9', label: 'Ute', description: 'Ute' },
    {
        level: '4',
        code: '1671-7',
        label: 'Allen Canyon',
        description: 'Allen Canyon'
    },
    {
        level: '4',
        code: '1672-5',
        label: 'Uintah Ute',
        description: 'Uintah Ute'
    },
    {
        level: '4',
        code: '1673-3',
        label: 'Ute Mountain Ute',
        description: 'Ute Mountain Ute'
    },
    { level: '4', code: '1675-8', label: 'Wailaki', description: 'Wailaki' },
    {
        level: '4',
        code: '1677-4',
        label: 'Walla-Walla',
        description: 'Walla-Walla'
    },
    {
        level: '4',
        code: '1679-0',
        label: 'Wampanoag',
        description: 'Wampanoag'
    },
    {
        level: '4',
        code: '1680-8',
        label: 'Gay Head Wampanoag',
        description: 'Gay Head Wampanoag'
    },
    {
        level: '4',
        code: '1681-6',
        label: 'Mashpee Wampanoag',
        description: 'Mashpee Wampanoag'
    },
    {
        level: '4',
        code: '1683-2',
        label: 'Warm Springs',
        description: 'Warm Springs'
    },
    { level: '4', code: '1685-7', label: 'Wascopum', description: 'Wascopum' },
    { level: '4', code: '1687-3', label: 'Washoe', description: 'Washoe' },
    { level: '4', code: '1688-1', label: 'Alpine', description: 'Alpine' },
    { level: '4', code: '1689-9', label: 'Carson', description: 'Carson' },
    {
        level: '4',
        code: '1690-7',
        label: 'Dresslerville',
        description: 'Dresslerville'
    },
    { level: '4', code: '1692-3', label: 'Wichita', description: 'Wichita' },
    {
        level: '4',
        code: '1694-9',
        label: 'Wind River',
        description: 'Wind River'
    },
    {
        level: '4',
        code: '1696-4',
        label: 'Winnebago',
        description: 'Winnebago'
    },
    { level: '4', code: '1697-2', label: 'Ho-chunk', description: 'Ho-chunk' },
    {
        level: '4',
        code: '1698-0',
        label: 'Nebraska Winnebago',
        description: 'Nebraska Winnebago'
    },
    {
        level: '4',
        code: '1700-4',
        label: 'Winnemucca',
        description: 'Winnemucca'
    },
    { level: '4', code: '1702-0', label: 'Wintun', description: 'Wintun' },
    { level: '4', code: '1704-6', label: 'Wiyot', description: 'Wiyot' },
    {
        level: '4',
        code: '1705-3',
        label: 'Table Bluff',
        description: 'Table Bluff'
    },
    { level: '4', code: '1707-9', label: 'Yakama', description: 'Yakama' },
    {
        level: '4',
        code: '1709-5',
        label: 'Yakama Cowlitz',
        description: 'Yakama Cowlitz'
    },
    { level: '4', code: '1711-1', label: 'Yaqui', description: 'Yaqui' },
    {
        level: '4',
        code: '1712-9',
        label: 'Barrio Libre',
        description: 'Barrio Libre'
    },
    {
        level: '4',
        code: '1713-7',
        label: 'Pascua Yaqui',
        description: 'Pascua Yaqui'
    },
    {
        level: '4',
        code: '1715-2',
        label: 'Yavapai Apache',
        description: 'Yavapai Apache'
    },
    { level: '4', code: '1717-8', label: 'Yokuts', description: 'Yokuts' },
    {
        level: '4',
        code: '1718-6',
        label: 'Chukchansi',
        description: 'Chukchansi'
    },
    { level: '4', code: '1719-4', label: 'Tachi', description: 'Tachi' },
    {
        level: '4',
        code: '1720-2',
        label: 'Tule River',
        description: 'Tule River'
    },
    { level: '4', code: '1722-8', label: 'Yuchi', description: 'Yuchi' },
    { level: '4', code: '1724-4', label: 'Yuman', description: 'Yuman' },
    { level: '4', code: '1725-1', label: 'Cocopah', description: 'Cocopah' },
    {
        level: '4',
        code: '1726-9',
        label: 'Havasupai',
        description: 'Havasupai'
    },
    { level: '4', code: '1727-7', label: 'Hualapai', description: 'Hualapai' },
    { level: '4', code: '1728-5', label: 'Maricopa', description: 'Maricopa' },
    { level: '4', code: '1729-3', label: 'Mohave', description: 'Mohave' },
    { level: '4', code: '1730-1', label: 'Quechan', description: 'Quechan' },
    { level: '4', code: '1731-9', label: 'Yavapai', description: 'Yavapai' },
    { level: '4', code: '1732-7', label: 'Yurok', description: 'Yurok' },
    {
        level: '4',
        code: '1733-5',
        label: 'Coast Yurok',
        description: 'Coast Yurok'
    },
    {
        level: '4',
        code: '1735-0',
        label: 'Alaska Native',
        description: 'Alaska Native'
    },
    {
        level: '4',
        code: '1737-6',
        label: 'Alaska Indian',
        description: 'Alaska Indian'
    },
    {
        level: '4',
        code: '1739-2',
        label: 'Alaskan Athabascan',
        description: 'Alaskan Athabascan'
    },
    { level: '4', code: '1740-0', label: 'Ahtna', description: 'Ahtna' },
    {
        level: '4',
        code: '1811-9',
        label: 'Southeast Alaska',
        description: 'Southeast Alaska'
    },
    {
        level: '4',
        code: '1813-5',
        label: 'Tlingit-Haida',
        description: 'Tlingit-Haida'
    },
    { level: '4', code: '1814-3', label: 'Angoon', description: 'Angoon' },
    {
        level: '4',
        code: '1815-0',
        label: 'Central Council of Tlingit and Haida Tribes',
        description: 'Central Council of Tlingit and Haida Tribes'
    },
    { level: '4', code: '1816-8', label: 'Chilkat', description: 'Chilkat' },
    { level: '4', code: '1817-6', label: 'Chilkoot', description: 'Chilkoot' },
    { level: '4', code: '1818-4', label: 'Craig', description: 'Craig' },
    { level: '4', code: '1819-2', label: 'Douglas', description: 'Douglas' },
    { level: '4', code: '1820-0', label: 'Haida', description: 'Haida' },
    { level: '4', code: '1821-8', label: 'Hoonah', description: 'Hoonah' },
    { level: '4', code: '1822-6', label: 'Hydaburg', description: 'Hydaburg' },
    { level: '4', code: '1823-4', label: 'Kake', description: 'Kake' },
    { level: '4', code: '1824-2', label: 'Kasaan', description: 'Kasaan' },
    { level: '4', code: '1825-9', label: 'Kenaitze', description: 'Kenaitze' },
    {
        level: '4',
        code: '1826-7',
        label: 'Ketchikan',
        description: 'Ketchikan'
    },
    { level: '4', code: '1827-5', label: 'Klawock', description: 'Klawock' },
    { level: '4', code: '1828-3', label: 'Pelican', description: 'Pelican' },
    {
        level: '4',
        code: '1829-1',
        label: 'Petersburg',
        description: 'Petersburg'
    },
    { level: '4', code: '1830-9', label: 'Saxman', description: 'Saxman' },
    { level: '4', code: '1831-7', label: 'Sitka', description: 'Sitka' },
    {
        level: '4',
        code: '1832-5',
        label: 'Tenakee Springs',
        description: 'Tenakee Springs'
    },
    { level: '4', code: '1833-3', label: 'Tlingit', description: 'Tlingit' },
    { level: '4', code: '1834-1', label: 'Wrangell', description: 'Wrangell' },
    { level: '4', code: '1835-8', label: 'Yakutat', description: 'Yakutat' },
    {
        level: '4',
        code: '1837-4',
        label: 'Tsimshian',
        description: 'Tsimshian'
    },
    {
        level: '4',
        code: '1838-2',
        label: 'Metlakatla',
        description: 'Metlakatla'
    },
    { level: '4', code: '1840-8', label: 'Eskimo', description: 'Eskimo' },
    {
        level: '4',
        code: '1842-4',
        label: 'Greenland Eskimo',
        description: 'Greenland Eskimo'
    },
    {
        level: '4',
        code: '1844-0',
        label: 'Inupiat Eskimo',
        description: 'Inupiat Eskimo'
    },
    { level: '4', code: '1845-7', label: 'Ambler', description: 'Ambler' },
    {
        level: '4',
        code: '1846-5',
        label: 'Anaktuvuk',
        description: 'Anaktuvuk'
    },
    {
        level: '4',
        code: '1847-3',
        label: 'Anaktuvuk Pass',
        description: 'Anaktuvuk Pass'
    },
    {
        level: '4',
        code: '1848-1',
        label: 'Arctic Slope Inupiat',
        description: 'Arctic Slope Inupiat'
    },
    {
        level: '4',
        code: '1849-9',
        label: 'Arctic Slope Corporation',
        description: 'Arctic Slope Corporation'
    },
    { level: '4', code: '1850-7', label: 'Atqasuk', description: 'Atqasuk' },
    { level: '4', code: '1851-5', label: 'Barrow', description: 'Barrow' },
    {
        level: '4',
        code: '1852-3',
        label: 'Bering Straits Inupiat',
        description: 'Bering Straits Inupiat'
    },
    {
        level: '4',
        code: '1853-1',
        label: 'Brevig Mission',
        description: 'Brevig Mission'
    },
    { level: '4', code: '1854-9', label: 'Buckland', description: 'Buckland' },
    { level: '4', code: '1855-6', label: 'Chinik', description: 'Chinik' },
    { level: '4', code: '1856-4', label: 'Council', description: 'Council' },
    { level: '4', code: '1857-2', label: 'Deering', description: 'Deering' },
    { level: '4', code: '1858-0', label: 'Elim', description: 'Elim' },
    { level: '4', code: '1859-8', label: 'Golovin', description: 'Golovin' },
    {
        level: '4',
        code: '1860-6',
        label: 'Inalik Diomede',
        description: 'Inalik Diomede'
    },
    { level: '4', code: '1861-4', label: 'Inupiaq', description: 'Inupiaq' },
    { level: '4', code: '1862-2', label: 'Kaktovik', description: 'Kaktovik' },
    { level: '4', code: '1863-0', label: 'Kawerak', description: 'Kawerak' },
    { level: '4', code: '1864-8', label: 'Kiana', description: 'Kiana' },
    { level: '4', code: '1865-5', label: 'Kivalina', description: 'Kivalina' },
    { level: '4', code: '1866-3', label: 'Kobuk', description: 'Kobuk' },
    { level: '4', code: '1867-1', label: 'Kotzebue', description: 'Kotzebue' },
    { level: '4', code: '1868-9', label: 'Koyuk', description: 'Koyuk' },
    { level: '4', code: '1869-7', label: 'Kwiguk', description: 'Kwiguk' },
    {
        level: '4',
        code: '1870-5',
        label: 'Mauneluk Inupiat',
        description: 'Mauneluk Inupiat'
    },
    {
        level: '4',
        code: '1871-3',
        label: 'Nana Inupiat',
        description: 'Nana Inupiat'
    },
    { level: '4', code: '1872-1', label: 'Noatak', description: 'Noatak' },
    { level: '4', code: '1873-9', label: 'Nome', description: 'Nome' },
    { level: '4', code: '1874-7', label: 'Noorvik', description: 'Noorvik' },
    { level: '4', code: '1875-4', label: 'Nuiqsut', description: 'Nuiqsut' },
    {
        level: '4',
        code: '1876-2',
        label: 'Point Hope',
        description: 'Point Hope'
    },
    {
        level: '4',
        code: '1877-0',
        label: 'Point Lay',
        description: 'Point Lay'
    },
    { level: '4', code: '1878-8', label: 'Selawik', description: 'Selawik' },
    {
        level: '4',
        code: '1879-6',
        label: 'Shaktoolik',
        description: 'Shaktoolik'
    },
    {
        level: '4',
        code: '1880-4',
        label: 'Shishmaref',
        description: 'Shishmaref'
    },
    { level: '4', code: '1881-2', label: 'Shungnak', description: 'Shungnak' },
    { level: '4', code: '1882-0', label: 'Solomon', description: 'Solomon' },
    { level: '4', code: '1883-8', label: 'Teller', description: 'Teller' },
    {
        level: '4',
        code: '1884-6',
        label: 'Unalakleet',
        description: 'Unalakleet'
    },
    {
        level: '4',
        code: '1885-3',
        label: 'Wainwright',
        description: 'Wainwright'
    },
    { level: '4', code: '1886-1', label: 'Wales', description: 'Wales' },
    {
        level: '4',
        code: '1887-9',
        label: 'White Mountain',
        description: 'White Mountain'
    },
    {
        level: '4',
        code: '1888-7',
        label: 'White Mountain Inupiat',
        description: 'White Mountain Inupiat'
    },
    {
        level: '4',
        code: '1889-5',
        label: "Mary's Igloo",
        description: "Mary's Igloo"
    },
    {
        level: '4',
        code: '1891-1',
        label: 'Siberian Eskimo',
        description: 'Siberian Eskimo'
    },
    { level: '4', code: '1892-9', label: 'Gambell', description: 'Gambell' },
    { level: '4', code: '1893-7', label: 'Savoonga', description: 'Savoonga' },
    {
        level: '4',
        code: '1894-5',
        label: 'Siberian Yupik',
        description: 'Siberian Yupik'
    },
    {
        level: '4',
        code: '1896-0',
        label: 'Yupik Eskimo',
        description: 'Yupik Eskimo'
    },
    { level: '4', code: '1897-8', label: 'Akiachak', description: 'Akiachak' },
    { level: '4', code: '1898-6', label: 'Akiak', description: 'Akiak' },
    { level: '4', code: '1899-4', label: 'Alakanuk', description: 'Alakanuk' },
    {
        level: '4',
        code: '1900-0',
        label: 'Aleknagik',
        description: 'Aleknagik'
    },
    {
        level: '4',
        code: '1901-8',
        label: 'Andreafsky',
        description: 'Andreafsky'
    },
    { level: '4', code: '1902-6', label: 'Aniak', description: 'Aniak' },
    {
        level: '4',
        code: '1903-4',
        label: 'Atmautluak',
        description: 'Atmautluak'
    },
    { level: '4', code: '1904-2', label: 'Bethel', description: 'Bethel' },
    {
        level: '4',
        code: '1905-9',
        label: "Bill Moore's Slough",
        description: "Bill Moore's Slough"
    },
    {
        level: '4',
        code: '1906-7',
        label: 'Bristol Bay Yupik',
        description: 'Bristol Bay Yupik'
    },
    {
        level: '4',
        code: '1907-5',
        label: 'Calista Yupik',
        description: 'Calista Yupik'
    },
    {
        level: '4',
        code: '1908-3',
        label: 'Chefornak',
        description: 'Chefornak'
    },
    { level: '4', code: '1909-1', label: 'Chevak', description: 'Chevak' },
    {
        level: '4',
        code: '1910-9',
        label: 'Chuathbaluk',
        description: 'Chuathbaluk'
    },
    {
        level: '4',
        code: '1911-7',
        label: "Clark's Point",
        description: "Clark's Point"
    },
    {
        level: '4',
        code: '1912-5',
        label: 'Crooked Creek',
        description: 'Crooked Creek'
    },
    {
        level: '4',
        code: '1913-3',
        label: 'Dillingham',
        description: 'Dillingham'
    },
    { level: '4', code: '1914-1', label: 'Eek', description: 'Eek' },
    { level: '4', code: '1915-8', label: 'Ekuk', description: 'Ekuk' },
    { level: '4', code: '1916-6', label: 'Ekwok', description: 'Ekwok' },
    { level: '4', code: '1917-4', label: 'Emmonak', description: 'Emmonak' },
    {
        level: '4',
        code: '1918-2',
        label: 'Goodnews Bay',
        description: 'Goodnews Bay'
    },
    {
        level: '4',
        code: '1919-0',
        label: 'Hooper Bay',
        description: 'Hooper Bay'
    },
    {
        level: '4',
        code: '1920-8',
        label: 'Iqurmuit (Russian Mission)',
        description: 'Iqurmuit (Russian Mission)'
    },
    { level: '4', code: '1921-6', label: 'Kalskag', description: 'Kalskag' },
    { level: '4', code: '1922-4', label: 'Kasigluk', description: 'Kasigluk' },
    { level: '4', code: '1923-2', label: 'Kipnuk', description: 'Kipnuk' },
    {
        level: '4',
        code: '1924-0',
        label: 'Koliganek',
        description: 'Koliganek'
    },
    {
        level: '4',
        code: '1925-7',
        label: 'Kongiganak',
        description: 'Kongiganak'
    },
    { level: '4', code: '1926-5', label: 'Kotlik', description: 'Kotlik' },
    { level: '4', code: '1927-3', label: 'Kwethluk', description: 'Kwethluk' },
    {
        level: '4',
        code: '1928-1',
        label: 'Kwigillingok',
        description: 'Kwigillingok'
    },
    { level: '4', code: '1929-9', label: 'Levelock', description: 'Levelock' },
    {
        level: '4',
        code: '1930-7',
        label: 'Lower Kalskag',
        description: 'Lower Kalskag'
    },
    {
        level: '4',
        code: '1931-5',
        label: 'Manokotak',
        description: 'Manokotak'
    },
    { level: '4', code: '1932-3', label: 'Marshall', description: 'Marshall' },
    { level: '4', code: '1933-1', label: 'Mekoryuk', description: 'Mekoryuk' },
    {
        level: '4',
        code: '1934-9',
        label: 'Mountain Village',
        description: 'Mountain Village'
    },
    { level: '4', code: '1935-6', label: 'Naknek', description: 'Naknek' },
    {
        level: '4',
        code: '1936-4',
        label: 'Napaumute',
        description: 'Napaumute'
    },
    { level: '4', code: '1937-2', label: 'Napakiak', description: 'Napakiak' },
    {
        level: '4',
        code: '1938-0',
        label: 'Napaskiak',
        description: 'Napaskiak'
    },
    { level: '4', code: '1939-8', label: 'Newhalen', description: 'Newhalen' },
    {
        level: '4',
        code: '1940-6',
        label: 'New Stuyahok',
        description: 'New Stuyahok'
    },
    { level: '4', code: '1941-4', label: 'Newtok', description: 'Newtok' },
    {
        level: '4',
        code: '1942-2',
        label: 'Nightmute',
        description: 'Nightmute'
    },
    {
        level: '4',
        code: '1943-0',
        label: 'Nunapitchukv',
        description: 'Nunapitchukv'
    },
    {
        level: '4',
        code: '1944-8',
        label: 'Oscarville',
        description: 'Oscarville'
    },
    {
        level: '4',
        code: '1945-5',
        label: 'Pilot Station',
        description: 'Pilot Station'
    },
    {
        level: '4',
        code: '1946-3',
        label: 'Pitkas Point',
        description: 'Pitkas Point'
    },
    { level: '4', code: '1947-1', label: 'Platinum', description: 'Platinum' },
    {
        level: '4',
        code: '1948-9',
        label: 'Portage Creek',
        description: 'Portage Creek'
    },
    {
        level: '4',
        code: '1949-7',
        label: 'Quinhagak',
        description: 'Quinhagak'
    },
    {
        level: '4',
        code: '1950-5',
        label: 'Red Devil',
        description: 'Red Devil'
    },
    {
        level: '4',
        code: '1951-3',
        label: 'St. Michael',
        description: 'St. Michael'
    },
    {
        level: '4',
        code: '1952-1',
        label: 'Scammon Bay',
        description: 'Scammon Bay'
    },
    {
        level: '4',
        code: '1953-9',
        label: "Sheldon's Point",
        description: "Sheldon's Point"
    },
    {
        level: '4',
        code: '1954-7',
        label: 'Sleetmute',
        description: 'Sleetmute'
    },
    { level: '4', code: '1955-4', label: 'Stebbins', description: 'Stebbins' },
    { level: '4', code: '1956-2', label: 'Togiak', description: 'Togiak' },
    { level: '4', code: '1957-0', label: 'Toksook', description: 'Toksook' },
    {
        level: '4',
        code: '1958-8',
        label: 'Tulukskak',
        description: 'Tulukskak'
    },
    {
        level: '4',
        code: '1959-6',
        label: 'Tuntutuliak',
        description: 'Tuntutuliak'
    },
    { level: '4', code: '1960-4', label: 'Tununak', description: 'Tununak' },
    {
        level: '4',
        code: '1961-2',
        label: 'Twin Hills',
        description: 'Twin Hills'
    },
    {
        level: '4',
        code: '1962-0',
        label: 'Georgetown',
        description: 'Georgetown'
    },
    {
        level: '4',
        code: '1963-8',
        label: "St. Mary's",
        description: "St. Mary's"
    },
    {
        level: '4',
        code: '1964-6',
        label: 'Umkumiate',
        description: 'Umkumiate'
    },
    { level: '4', code: '1966-1', label: 'Aleut', description: 'Aleut' },
    {
        level: '4',
        code: '1968-7',
        label: 'Alutiiq Aleut',
        description: 'Alutiiq Aleut'
    },
    { level: '4', code: '1969-5', label: 'Tatitlek', description: 'Tatitlek' },
    { level: '4', code: '1970-3', label: 'Ugashik', description: 'Ugashik' },
    {
        level: '4',
        code: '1972-9',
        label: 'Bristol Bay Aleut',
        description: 'Bristol Bay Aleut'
    },
    { level: '4', code: '1973-7', label: 'Chignik', description: 'Chignik' },
    {
        level: '4',
        code: '1974-5',
        label: 'Chignik Lake',
        description: 'Chignik Lake'
    },
    { level: '4', code: '1975-2', label: 'Egegik', description: 'Egegik' },
    { level: '4', code: '1976-0', label: 'Igiugig', description: 'Igiugig' },
    {
        level: '4',
        code: '1977-8',
        label: 'Ivanof Bay',
        description: 'Ivanof Bay'
    },
    {
        level: '4',
        code: '1978-6',
        label: 'King Salmon',
        description: 'King Salmon'
    },
    { level: '4', code: '1979-4', label: 'Kokhanok', description: 'Kokhanok' },
    {
        level: '4',
        code: '1980-2',
        label: 'Perryville',
        description: 'Perryville'
    },
    {
        level: '4',
        code: '1981-0',
        label: 'Pilot Point',
        description: 'Pilot Point'
    },
    {
        level: '4',
        code: '1982-8',
        label: 'Port Heiden',
        description: 'Port Heiden'
    },
    {
        level: '4',
        code: '1984-4',
        label: 'Chugach Aleut',
        description: 'Chugach Aleut'
    },
    { level: '4', code: '1985-1', label: 'Chenega', description: 'Chenega' },
    {
        level: '4',
        code: '1986-9',
        label: 'Chugach Corporation',
        description: 'Chugach Corporation'
    },
    {
        level: '4',
        code: '1987-7',
        label: 'English Bay',
        description: 'English Bay'
    },
    {
        level: '4',
        code: '1988-5',
        label: 'Port Graham',
        description: 'Port Graham'
    },
    { level: '4', code: '1990-1', label: 'Eyak', description: 'Eyak' },
    {
        level: '4',
        code: '1992-7',
        label: 'Koniag Aleut',
        description: 'Koniag Aleut'
    },
    { level: '4', code: '1993-5', label: 'Akhiok', description: 'Akhiok' },
    { level: '4', code: '1994-3', label: 'Agdaagux', description: 'Agdaagux' },
    { level: '4', code: '1995-0', label: 'Karluk', description: 'Karluk' },
    { level: '4', code: '1996-8', label: 'Kodiak', description: 'Kodiak' },
    {
        level: '4',
        code: '1997-6',
        label: 'Larsen Bay',
        description: 'Larsen Bay'
    },
    {
        level: '4',
        code: '1998-4',
        label: 'Old Harbor',
        description: 'Old Harbor'
    },
    { level: '4', code: '1999-2', label: 'Ouzinkie', description: 'Ouzinkie' },
    {
        level: '4',
        code: '2000-8',
        label: 'Port Lions',
        description: 'Port Lions'
    },
    { level: '4', code: '2002-4', label: 'Sugpiaq', description: 'Sugpiaq' },
    { level: '4', code: '2004-0', label: 'Suqpigaq', description: 'Suqpigaq' },
    {
        level: '4',
        code: '2006-5',
        label: 'Unangan Aleut',
        description: 'Unangan Aleut'
    },
    { level: '4', code: '2007-3', label: 'Akutan', description: 'Akutan' },
    {
        level: '4',
        code: '2008-1',
        label: 'Aleut Corporation',
        description: 'Aleut Corporation'
    },
    { level: '4', code: '2009-9', label: 'Aleutian', description: 'Aleutian' },
    {
        level: '4',
        code: '2010-7',
        label: 'Aleutian Islander',
        description: 'Aleutian Islander'
    },
    { level: '4', code: '2011-5', label: 'Atka', description: 'Atka' },
    {
        level: '4',
        code: '2012-3',
        label: 'Belkofski',
        description: 'Belkofski'
    },
    {
        level: '4',
        code: '2013-1',
        label: 'Chignik Lagoon',
        description: 'Chignik Lagoon'
    },
    {
        level: '4',
        code: '2014-9',
        label: 'King Cove',
        description: 'King Cove'
    },
    {
        level: '4',
        code: '2015-6',
        label: 'False Pass',
        description: 'False Pass'
    },
    {
        level: '4',
        code: '2016-4',
        label: 'Nelson Lagoon',
        description: 'Nelson Lagoon'
    },
    { level: '4', code: '2017-2', label: 'Nikolski', description: 'Nikolski' },
    {
        level: '4',
        code: '2018-0',
        label: 'Pauloff Harbor',
        description: 'Pauloff Harbor'
    },
    {
        level: '4',
        code: '2019-8',
        label: 'Qagan Toyagungin',
        description: 'Qagan Toyagungin'
    },
    {
        level: '4',
        code: '2020-6',
        label: 'Qawalangin',
        description: 'Qawalangin'
    },
    {
        level: '4',
        code: '2021-4',
        label: 'St. George',
        description: 'St. George'
    },
    { level: '4', code: '2022-2', label: 'St. Paul', description: 'St. Paul' },
    {
        level: '4',
        code: '2023-0',
        label: 'Sand Point',
        description: 'Sand Point'
    },
    {
        level: '4',
        code: '2024-8',
        label: 'South Naknek',
        description: 'South Naknek'
    },
    { level: '4', code: '2025-5', label: 'Unalaska', description: 'Unalaska' },
    { level: '4', code: '2026-3', label: 'Unga', description: 'Unga' },
    {
        level: '4',
        code: '2029-7',
        label: 'Asian Indian',
        description: 'Asian Indian'
    },
    {
        level: '4',
        code: '2030-5',
        label: 'Bangladeshi',
        description: 'Bangladeshi'
    },
    {
        level: '4',
        code: '2031-3',
        label: 'Bhutanese',
        description: 'Bhutanese'
    },
    { level: '4', code: '2032-1', label: 'Burmese', description: 'Burmese' },
    {
        level: '4',
        code: '2033-9',
        label: 'Cambodian',
        description: 'Cambodian'
    },
    { level: '4', code: '2034-7', label: 'Chinese', description: 'Chinese' },
    {
        level: '4',
        code: '2035-4',
        label: 'Taiwanese',
        description: 'Taiwanese'
    },
    { level: '4', code: '2036-2', label: 'Filipino', description: 'Filipino' },
    { level: '4', code: '2037-0', label: 'Hmong', description: 'Hmong' },
    {
        level: '4',
        code: '2038-8',
        label: 'Indonesian',
        description: 'Indonesian'
    },
    { level: '4', code: '2039-6', label: 'Japanese', description: 'Japanese' },
    { level: '4', code: '2040-4', label: 'Korean', description: 'Korean' },
    { level: '4', code: '2041-2', label: 'Laotian', description: 'Laotian' },
    {
        level: '4',
        code: '2042-0',
        label: 'Malaysian',
        description: 'Malaysian'
    },
    { level: '4', code: '2043-8', label: 'Okinawan', description: 'Okinawan' },
    {
        level: '4',
        code: '2044-6',
        label: 'Pakistani',
        description: 'Pakistani'
    },
    {
        level: '4',
        code: '2045-3',
        label: 'Sri Lankan',
        description: 'Sri Lankan'
    },
    { level: '4', code: '2046-1', label: 'Thai', description: 'Thai' },
    {
        level: '4',
        code: '2047-9',
        label: 'Vietnamese',
        description: 'Vietnamese'
    },
    {
        level: '4',
        code: '2048-7',
        label: 'Iwo Jiman',
        description: 'Iwo Jiman'
    },
    {
        level: '4',
        code: '2049-5',
        label: 'Maldivian',
        description: 'Maldivian'
    },
    { level: '4', code: '2050-3', label: 'Nepalese', description: 'Nepalese' },
    {
        level: '4',
        code: '2051-1',
        label: 'Singaporean',
        description: 'Singaporean'
    },
    {
        level: '4',
        code: '2052-9',
        label: 'Madagascar',
        description: 'Madagascar'
    },
    {
        level: '4',
        code: '2054-5',
        label: 'Black or African American',
        description: 'Black or African American'
    },
    { level: '4', code: '2056-0', label: 'Black', description: 'Black' },
    {
        level: '4',
        code: '2061-0',
        label: 'Botswanan',
        description: 'Botswanan'
    },
    {
        level: '4',
        code: '2062-8',
        label: 'Ethiopian',
        description: 'Ethiopian'
    },
    { level: '4', code: '2063-6', label: 'Liberian', description: 'Liberian' },
    { level: '4', code: '2064-4', label: 'Namibian', description: 'Namibian' },
    { level: '4', code: '2065-1', label: 'Nigerian', description: 'Nigerian' },
    { level: '4', code: '2066-9', label: 'Zairean', description: 'Zairean' },
    { level: '4', code: '2067-7', label: 'Bahamian', description: 'Bahamian' },
    {
        level: '4',
        code: '2068-5',
        label: 'Barbadian',
        description: 'Barbadian'
    },
    {
        level: '4',
        code: '2069-3',
        label: 'Dominican',
        description: 'Dominican'
    },
    {
        level: '4',
        code: '2070-1',
        label: 'Dominica Islander',
        description: 'Dominica Islander'
    },
    { level: '4', code: '2071-9', label: 'Haitian', description: 'Haitian' },
    { level: '4', code: '2072-7', label: 'Jamaican', description: 'Jamaican' },
    { level: '4', code: '2073-5', label: 'Tobagoan', description: 'Tobagoan' },
    {
        level: '4',
        code: '2074-3',
        label: 'Trinidadian',
        description: 'Trinidadian'
    },
    {
        level: '4',
        code: '2075-0',
        label: 'West Indian',
        description: 'West Indian'
    },
    {
        level: '4',
        code: '2078-4',
        label: 'Polynesian',
        description: 'Polynesian'
    },
    {
        level: '4',
        code: '2079-2',
        label: 'Native Hawaiian',
        description: 'Native Hawaiian'
    },
    { level: '4', code: '2080-0', label: 'Samoan', description: 'Samoan' },
    { level: '4', code: '2081-8', label: 'Tahitian', description: 'Tahitian' },
    { level: '4', code: '2082-6', label: 'Tongan', description: 'Tongan' },
    {
        level: '4',
        code: '2083-4',
        label: 'Tokelauan',
        description: 'Tokelauan'
    },
    {
        level: '4',
        code: '2085-9',
        label: 'Micronesian',
        description: 'Micronesian'
    },
    {
        level: '4',
        code: '2086-7',
        label: 'Guamanian or Chamorro',
        description: 'Guamanian or Chamorro'
    },
    {
        level: '4',
        code: '2087-5',
        label: 'Guamanian',
        description: 'Guamanian'
    },
    { level: '4', code: '2088-3', label: 'Chamorro', description: 'Chamorro' },
    {
        level: '4',
        code: '2089-1',
        label: 'Mariana Islander',
        description: 'Mariana Islander'
    },
    {
        level: '4',
        code: '2090-9',
        label: 'Marshallese',
        description: 'Marshallese'
    },
    { level: '4', code: '2091-7', label: 'Palauan', description: 'Palauan' },
    {
        level: '4',
        code: '2092-5',
        label: 'Carolinian',
        description: 'Carolinian'
    },
    { level: '4', code: '2093-3', label: 'Kosraean', description: 'Kosraean' },
    {
        level: '4',
        code: '2094-1',
        label: 'Pohnpeian',
        description: 'Pohnpeian'
    },
    {
        level: '4',
        code: '2095-8',
        label: 'Saipanese',
        description: 'Saipanese'
    },
    { level: '4', code: '2096-6', label: 'Kiribati', description: 'Kiribati' },
    { level: '4', code: '2097-4', label: 'Chuukese', description: 'Chuukese' },
    { level: '4', code: '2098-2', label: 'Yapese', description: 'Yapese' },
    {
        level: '4',
        code: '2100-6',
        label: 'Melanesian',
        description: 'Melanesian'
    },
    { level: '4', code: '2101-4', label: 'Fijian', description: 'Fijian' },
    {
        level: '4',
        code: '2102-2',
        label: 'Papua New Guinean',
        description: 'Papua New Guinean'
    },
    {
        level: '4',
        code: '2103-0',
        label: 'Solomon Islander',
        description: 'Solomon Islander'
    },
    {
        level: '4',
        code: '2104-8',
        label: 'New Hebrides',
        description: 'New Hebrides'
    },
    {
        level: '4',
        code: '2500-7',
        label: 'Other Pacific Islander',
        description:
            'Note that this term remains in the table for completeness, even though within HL7, the notion of Other code is deprecated.'
    },
    { level: '4', code: '2109-7', label: 'Armenian', description: 'Armenian' },
    { level: '4', code: '2110-5', label: 'English', description: 'English' },
    { level: '4', code: '2111-3', label: 'French', description: 'French' },
    { level: '4', code: '2112-1', label: 'German', description: 'German' },
    { level: '4', code: '2113-9', label: 'Irish', description: 'Irish' },
    { level: '4', code: '2114-7', label: 'Italian', description: 'Italian' },
    { level: '4', code: '2115-4', label: 'Polish', description: 'Polish' },
    { level: '4', code: '2116-2', label: 'Scottish', description: 'Scottish' },
    { level: '4', code: '2119-6', label: 'Assyrian', description: 'Assyrian' },
    { level: '4', code: '2120-4', label: 'Egyptian', description: 'Egyptian' },
    { level: '4', code: '2121-2', label: 'Iranian', description: 'Iranian' },
    { level: '4', code: '2122-0', label: 'Iraqi', description: 'Iraqi' },
    { level: '4', code: '2123-8', label: 'Lebanese', description: 'Lebanese' },
    {
        level: '4',
        code: '2124-6',
        label: 'Palestinian',
        description: 'Palestinian'
    },
    { level: '4', code: '2125-3', label: 'Syrian', description: 'Syrian' },
    {
        level: '4',
        code: '2126-1',
        label: 'Afghanistani',
        description: 'Afghanistani'
    },
    { level: '4', code: '2127-9', label: 'Israeili', description: 'Israeili' },
    { level: '4', code: '2129-5', label: 'Arab', description: 'Arab' }
];
